import type { EssencialOpcional, GrupoItemRegra } from '../../types'

export const ROTULO_ESSENCIAL: Record<EssencialOpcional, string> = { 0: 'Sem classificação', 1: 'Essencial', 2: 'Opcional' }
export const VARIANTE_ESSENCIAL: Record<EssencialOpcional, 'income' | 'warning' | 'muted'> = { 1: 'income', 2: 'warning', 0: 'muted' }

/** "LEITE|PO" vira "LEITE + PO": todos os termos precisam aparecer na descrição. */
export const termosLegiveis = (t: string) => t.split('|').map((x) => x.trim()).filter(Boolean).join(' + ')

/** Resumo das regras: Aceita: A + B ou C · Recusa: D, E. */
export function resumoRegras(regras: GrupoItemRegra[]): string {
  const aceita = regras.filter((r) => r.tipo === 1).map((r) => termosLegiveis(r.termos))
  const recusa = regras.filter((r) => r.tipo === 2).map((r) => termosLegiveis(r.termos))
  return [aceita.length ? `Aceita: ${aceita.join(' ou ')}` : '', recusa.length ? `Recusa: ${recusa.join(', ')}` : ''].filter(Boolean).join(' · ') || 'Sem regras ainda.'
}
